import { useEffect, useState } from 'react'
import { CookieConsentStatus } from './types'

export const defaultCookieConsentStatus: CookieConsentStatus = {
  necessary: true,
  preferences: false,
  statistics: false,
  marketing: false,
}

/**
 * Determines if marketing consent is granted in Cookiebot.
 */
export const isMarketingConsentGranted = () => {
  return window.Cookiebot?.consent?.marketing === true
}

/**
 * Hook that reads cookie consent status from Cookiebot.
 */
export const useCookieConsentStatus = () => {
  const [cookieConsentStatus, setCookieConsentStatus] =
    useState<CookieConsentStatus>(defaultCookieConsentStatus)

  // Handle Cookiebot events
  useEffect(() => {
    function handleCookiebotConsentChange() {
      if (!window.Cookiebot) {
        return
      }

      setCookieConsentStatus({
        necessary: window.Cookiebot.consent.necessary,
        preferences: window.Cookiebot.consent.preferences,
        statistics: window.Cookiebot.consent.statistics,
        marketing: window.Cookiebot.consent.marketing,
      })
    }

    window.addEventListener(
      'CookiebotOnConsentReady',
      handleCookiebotConsentChange,
    )
    window.addEventListener('CookiebotOnAccept', handleCookiebotConsentChange)
    window.addEventListener('CookiebotOnDecline', handleCookiebotConsentChange)

    return () => {
      window.removeEventListener(
        'CookiebotOnConsentReady',
        handleCookiebotConsentChange,
      )
      window.removeEventListener(
        'CookiebotOnAccept',
        handleCookiebotConsentChange,
      )
      window.removeEventListener(
        'CookiebotOnDecline',
        handleCookiebotConsentChange,
      )
    }
  }, [])

  return cookieConsentStatus
}
